import React from "react";
import { Link } from "react-router-dom"; // For navigation, adjust based on your routing setup.

const NotFoundPage = (title) => {
  document.title = title.title;
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-r from-blue-200 via-pink-200 to-yellow-200">
      <div className="text-center">
        <h1 className="text-6xl font-extrabold text-gray-800">404</h1>
        <p className="text-2xl text-gray-600 mt-4">Oops! The page you're looking for doesn't exist.</p>
        <div className="mt-6">
          <Link
            to="/"
            className="border-black border-2 text-black py-2 px-6 rounded-full text-lg hover:bg-white  transition duration-300"
          >
            Go Back to Home
          </Link>
        </div>
   
      </div>
      <div className="absolute bottom-6 text-center text-gray-500">
        <p>&copy; 2025 ClickStar. All Rights Reserved.</p>
      </div>
    </div>
  );
};

export default NotFoundPage;
